

const CookieConfig = {
    param: null,
    object: { path: '/' }
};

export default CookieConfig